export default "__VITE_ASSET__CwglrnzI__"